import {
  DATE_TIME_FORMAT_1,
  TransactionOption,
  TransactionOptionName,
} from "@app/constants";
import TransactionService from "@app/services/http/transaction.service";
import { TransactionHistory } from "@app/types";
import { formatDateTime, formatMoneyVN } from "@app/utils/util";
import { Images } from "@assets/images";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import clsx from "clsx";
import { useEffect, useState } from "react";

function TransactionTab() {
  const [transactionHistories, setTransactionHistories] = useState<
    TransactionHistory[]
  >([]);

  const { abortController } = useCancellationRequest();

  useEffect(() => {
    TransactionService.getTransactionHistories(abortController.signal).then(
      (res) => {
        setTransactionHistories(res.data.items);
      }
    );
  }, []);

  return (
    <div className="mt-10">
      {transactionHistories.length ? (
        <div className="flex flex-wrap gap-8">
          {transactionHistories.map((purchase) => (
            <div
              key={purchase.id}
              className="w-[400px] min-h-[214px] bg-white rounded-md p-5"
            >
              <p className="mt-2 font-[SVN-Gilroy]">
                Thời gian:{" "}
                {formatDateTime(purchase.createdDate, DATE_TIME_FORMAT_1)}
              </p>
              <p className="mt-2 font-[SVN-Gilroy]">
                Số tiền: <strong>{formatMoneyVN(purchase.money)} VND</strong>
              </p>
              <p className="mt-2 font-[SVN-Gilroy]">
                Hình thức: {purchase.formality}
              </p>
              <p className="mt-2 font-[SVN-Gilroy]">
                Nội dung: {purchase.content}
              </p>
              <div
                className={clsx(
                  "mt-3 px-4 py-2 rounded-lg font-medium font-[SVN-Gilroy] w-fit",
                  {
                    "bg-[#E8FFF4] text-[#38499b]":
                      purchase.status === TransactionOption.SUCCESS,
                    "bg-[#FFF0E6] text-[#FE7E20]":
                      purchase.status === TransactionOption.TIMEOUT,
                    "bg-[#CCE7FF] text-[#4558FF]":
                      purchase.status === TransactionOption.PROCESSING,
                    "bg-[#FFEBEB] text-[#FC4040]":
                      purchase.status === TransactionOption.ERROR,
                  }
                )}
              >
                {TransactionOptionName[purchase.status]}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center mt-32">
          <img src={Images.NoData.default} />
        </div>
      )}
    </div>
  );
}

export default TransactionTab;
